export default {
    bekendURI: import.meta.env.VITE_API_URL,
    openApiFileLocation: `${import.meta.env.VITE_API_URL}/openapi.json`,
    longDateTimeFormatOptions: {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
    } as const,
    requests: {
        concurrency: 3,
    },
    gDrivePicker: {
        apiKey: import.meta.env.VITE_GDRIVE_PICKER_API_KEY,
        clientId: import.meta.env.VITE_GDRIVE_CLIENT_ID,
        scope: "https://www.googleapis.com/auth/drive.readonly",
    },
    authentication: {
        firebase: {
            apiKey: import.meta.env.VUE_APP_API_KEY,
            authDomain: import.meta.env.VUE_APP_AUTH_DOMAIN,
            databaseURL: import.meta.env.VUE_APP_DATABASE_URL,
            projectId: import.meta.env.VUE_APP_PROJECT_ID,
            storageBucket: import.meta.env.VUE_APP_STORAGE_BUCKET,
            messagingSenderId: import.meta.env.VUE_APP_MESSAGING_SENDER_ID,
            appId: import.meta.env.VUE_APP_APP_ID,
            measurementId: import.meta.env.VUE_APP_MEASUREMENT_ID,
            emulatorUrl: import.meta.env.VITE_FIREBASE_EMULATOR_URL,
        },
    },
    features: {
        spex: false,
    },
};
